import { Fragment, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Button, Col, DatePicker, Input, message, Modal, Row, Select, Space, Upload } from "antd"
import { UploadOutlined, DeleteOutlined } from '@ant-design/icons'
import { baseAxiosComplete, baseAxiosNoInfo } from "../../../tool/axios"
import { apiPrefix } from "../../../js/config"
import _ from 'lodash'

interface leftAmount {
    agreement_amount: number // 合同总金额
    total_agreement_pay_amount: number // 合同已收金额
    total_agreement_left_amount: number // 合同待收金额
    total_agreement_refund_amount: number // 合同退款金额
}

interface reciveRow {
    pay_date: undefined | string, // 付款日期，例如“2021-06-30”
    pay_item: undefined | number, // 付款项目，3一对一陪护 4合同尾款 11套餐升级
    pay_code: undefined | string, // 收款单号
    pay_way: undefined | number, // 付款方式，1现金 2支付宝 3微信 4银联卡
    pay_amount: undefined | string, // 付款金额，小数类型
    pay_prov_pic_list: undefined | string[], // 付款收据图片集合，上传图片接口返回的图片路径
    pay_operator_id: undefined | string, // 收款操作人，“全局-查询某个组织某个职位的员工列表”接口（注意要传store_id查询）返回的employee_id字段
    remark: undefined | string
}

interface ep {
    "employee_id": string,
    "user_name": string
}

interface Prop {
    storeID?: string
}

const { Option } = Select

const upLoadProps = {
    name: 'files',
    data: { fileType: 1, bucketType: 4 },
    action: apiPrefix + '/global/upload_pic',
}

export default function (prop: Prop) {

    const param: { id: string } = useParams()
    const [data, setData] = useState<leftAmount>()
    const [visible, setVisible] = useState<boolean>(false)
    const [reciveMan, setReciveMan] = useState<ep[]>([])

    let reciveMoneyRow: reciveRow = {
        pay_date: undefined,
        pay_item: undefined,
        pay_code: undefined,
        pay_way: undefined,
        pay_amount: undefined,
        pay_prov_pic_list: [],
        pay_operator_id: undefined,
        remark: undefined
    }

    const [reciveMoneyData, setReciveMoneyData] = useState<reciveRow[]>([{
        pay_date: undefined,
        pay_item: undefined,
        pay_code: undefined,
        pay_way: undefined,
        pay_amount: undefined,
        pay_prov_pic_list: [],
        pay_operator_id: undefined,
        remark: undefined
    }])

    const addMoreRow = () => {
        setReciveMoneyData([...reciveMoneyData, reciveMoneyRow])
    }

    const deleteRow = (index: number) => {
        if (reciveMoneyData.length > 1) {
            let reciveD = _.cloneDeep(reciveMoneyData)
            reciveD.splice(index, 1)

            setReciveMoneyData(reciveD)
        }
    }

    const handleChange = (index: number, attr: string, value: any) => {
        let reciveD: any = _.cloneDeep(reciveMoneyData)
        reciveD[index][attr] = value

        setReciveMoneyData(reciveD)
    }

    const uploadChange = (info: any, index: number) => {
        let reciveD: any = _.cloneDeep(reciveMoneyData)

        if (info.file.status === 'done') {
            message.success(`${info.file.name} 上传成功`)
            reciveD[index].pay_prov_pic_list.push(info.file.response.data[0])

            setReciveMoneyData(reciveD)

        } else if (info.file.status === 'error') {
            message.error(`${info.file.name} file upload failed.`);

        } else if (info.file.status === 'removed') {
            let i = reciveD[index].pay_prov_pic_list.findIndex((el: string) => el === info.file.response.data[0])
            reciveD[index].pay_prov_pic_list.splice(i, 1)

            setReciveMoneyData(reciveD)
        }
    }

    useEffect(() => {
        baseAxiosNoInfo('/keeper/check_in/left_amount/info', {
            params: {
                check_in_id: param.id,
                type: 0
            }

        }).then((res: any) => {
            res && setData(res)
        })

    }, [])

    useEffect(() => {
        if (prop.storeID) {
            baseAxiosNoInfo('/global/employee_list_by_position', {
                params: {
                    department_id: prop.storeID,
                    position_number: '22,26'
                }

            }).then((res: any) => {
                res && setReciveMan(res)
            })
        }
    }, [prop.storeID])

    const onFinish = () => {
        baseAxiosComplete.post('/keeper/check_in/pay_amount/add', {
            check_in_id: param.id,
            pay_detail: reciveMoneyData

        }).then(res => {
            if (res.status === 0) {
                message.success(`录入成功`)
                setVisible(false)
            }
        })
    }

    return <Fragment>
        {/* 管家中心 -> 入住管理 -> 客户详情 -> 录入收款 */}
        <Button type="primary" style={{ marginLeft: 16, marginBottom: 16 }} size="small" onClick={() => { setVisible(true) }}>录入收款</Button>

        <Modal title="录入收款" width={1100} visible={visible} onCancel={() => { setVisible(false) }} onOk={onFinish}>
            <Space>
                <p>合同总金额：{data?.agreement_amount}元</p>
                <p>合同已收金额：{data?.total_agreement_pay_amount}元</p>
                <p>合同待收金额：{data?.total_agreement_left_amount}元</p>
                <p>合同退款金额：{data?.total_agreement_refund_amount}元</p>
            </Space>

            <Row style={{ marginBottom: 16 }} gutter={8} justify="space-around">
                <Col span={3}>收款日期<span style={{ color: "red" }}>*</span></Col>
                <Col span={3}>付款项目<span style={{ color: "red" }}>*</span></Col>
                <Col span={3}>收款单号<span style={{ color: "red" }}>*</span></Col>
                <Col span={3}>收款方式<span style={{ color: "red" }}>*</span></Col>
                <Col span={2}>收款金额<span style={{ color: "red" }}>*</span></Col>
                <Col span={3}>收款凭证<span style={{ color: "red" }}>*</span></Col>
                <Col span={3}>备注</Col>
                <Col span={1}></Col>
            </Row>

            {reciveMoneyData.map((el, index: number) =>
                <Row gutter={8} justify="space-around" style={{ marginBottom: 8, userSelect: 'none' }}>
                    <Col span={3}>
                        <DatePicker onChange={(v: any) => {
                            handleChange(index, 'pay_date', v.format('YYYY-MM-DD'))
                        }} />
                    </Col>
                    <Col span={3}>
                        <Select value={el.pay_item} style={{ width: '100%' }} onChange={(v: number) => {
                            handleChange(index, 'pay_item', v)
                        }}>
                            <Option key={4} value={4}>合同尾款</Option>
                            <Option key={3} value={3}>一对一陪护</Option>
                            <Option key={5} value={5}>医院陪护</Option>
                            <Option key={6} value={6}>月嫂到家</Option>
                            <Option key={10} value={10}>入住押金</Option>
                            <Option key={11} value={11}>套餐升级</Option>
                            <Option key={13} value={13}>胎发</Option>
                            <Option key={14} value={14}>宝宝护理</Option>
                        </Select>
                    </Col>
                    <Col span={3}>
                        <Input value={el.pay_code} onChange={(v) => {
                            handleChange(index, 'pay_code', v.target.value)
                        }} />
                    </Col>
                    <Col span={3}>
                        <Select value={el.pay_way} style={{ width: '100%' }} onChange={(v: number) => {
                            handleChange(index, 'pay_way', v)
                        }}>
                            <Option key={1} value={1}>现金</Option>
                            <Option key={2} value={2}>支付宝</Option>
                            <Option key={3} value={3}>微信</Option>
                            <Option key={4} value={4}>银联卡</Option>
                            <Option key={5} value={5}>押金抵扣</Option>
                            <Option key={6} value={6}>小精灵</Option>
                            <Option key={7} value={7}>对公转账</Option>
                            <Option key={8} value={8}>抵扣券</Option>
                        </Select>
                    </Col>
                    <Col span={2}>
                        <Input value={el.pay_amount} onChange={(e) => {
                            handleChange(index, 'pay_amount', e.target.value)
                        }} />
                    </Col>
                    <Col span={3} style={{ paddingTop: 4 }}>
                        <Space>
                            <Upload {...upLoadProps} onChange={(info: any) => {
                                uploadChange(info, index)
                            }}>
                                <Button icon={<UploadOutlined />} size="small" ></Button>
                            </Upload>
                        </Space>
                    </Col>
                    <Col span={3}>
                        <Input value={el.remark} onChange={(v) => {
                            handleChange(index, 'remark', v.target.value)
                        }} />
                    </Col>
                    <Col span={1} style={{ paddingTop: 4 }}>
                        <DeleteOutlined onClick={() => {
                            deleteRow(index)
                        }} style={{ cursor: 'pointer' }} />
                    </Col>
                </Row>
            )}

            <Button onClick={addMoreRow} style={{ marginTop: 16 }} size="small" type="primary">添加收款</Button>
        </Modal>
    </Fragment>
}